import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CommonService } from '../shared/common.service'
import { CrudRepository } from '../shared/crud.repository'

/**
 * Servicios para obtener informacion referentes a eventos.
 *
 * @export
 * @class EventsRepository
 * @extends {CrudRepository}
 */
@Injectable({
  providedIn: 'root',
})
export class EventsRepository extends CrudRepository {
  /**
   * Creates an instance of EventsRepository.
   * @param {HttpClient} _httpClient
   * @param {CommonService} _commonService
   * @memberof EventsService
   */
  constructor(protected _httpClient: HttpClient, protected _commonService: CommonService) {
    super(_httpClient, _commonService, 'event')
  }
}
